<!-- 애니매이션 미리보기 뷰 -->
<template>
  <div @mouseover="handleMouseOver" ref="component" class="rounded-lg" style="overflow: hidden; background:white !important"/>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Component_Model from '@/nextts/model/Component_Model'
import { ref, reactive, markRaw } from '@vue/reactivity';
import EditBasic_Element from '@/nextts/edit/EditBasic_Element'
import { useContentStore } from "@/stores/content";
import AnimationPlay_Model from '@/nextts/model/AnimationPlay_Model';
import gsap from "gsap";

export default {

props:{
  anidata:AnimationPlay_Model
},

setup(){
  const component = ref(null);
  const contentStore = useContentStore();
  return {component, contentStore};
},

data:()=>({
  model: null,
  anielement: null,
  isAnimating: false,
  timeline: null,      // 타임라인을 data에 정의
  aniplayData: null    // 애니메이션 데이터 저장
}),

mounted(){
  //컴포넌트의 크기, 위치 설정
  this.component.style.cssText += "width:120px;height:90px;rotate(0deg);background:black"; 
  this.component.style.transformOrigin = "0% 0%";
  this.component.style.transform = 'scale(1)';
  
  this.model = new Component_Model();
  this.model.width  = 40;
  this.model.height = 40;
  this.model.component_type = Component_Model.COMPONENT_ANISHOW;
  this.model.posx   = 0;
  this.model.posy   = 0;
  this.model.rotate = 0;

  this.model.scalex   = 1;
  this.model.scaley   = 1;
  this.model.rotatex  = 0;
  this.model.rotatey  = 0;
  this.model.skewx    = 0;
  this.model.skewy    = 0;

  this.model.transx = 40;
  this.model.transy = 25;

  this.anielement = new EditBasic_Element(reactive(this.model));
  this.component.appendChild(this.anielement);

  // 애니메이션 데이터 준비
  this.prepareAnimation();
},

beforeUnmount(){
  // 타임라인 정리
  this.cleanupTimeline();
},

methods:{
  // 마우스 오버 핸들러
  handleMouseOver() {
    //console.log("마우스 오버 이벤트 발생");
    
    // 이미 애니메이션이 실행 중이면 무시
    if (this.isAnimating) {
      //console.log("이미 애니메이션 실행 중 - 무시");
      return;
    }
    
    // 애니메이션 실행
    this.playAnimation();
  },

  // 타임라인 정리 메서드
  cleanupTimeline() {
    if (this.timeline) {
      //console.log("타임라인 정리");
      this.timeline.kill();
      this.timeline = null;
    }
  },

  // 애니메이션 데이터 준비
  prepareAnimation() {
    try {
      if (!this.anidata || !this.anidata.ANI_JSON) {
        //console.log("애니메이션 데이터가 없습니다");
        return false;
      }

      const aniplay = new AnimationPlay_Model();
      aniplay.setStringValue(this.anidata.ANI_JSON);

      if (!aniplay.anilist || aniplay.anilist.length < 1) {
        //console.log("애니메이션 리스트가 비어있습니다");
        return false;
      }

      // markRaw를 사용하여 반응성 제거 후 저장
      this.aniplayData = markRaw(aniplay);
      //console.log("애니메이션 데이터 준비 완료:", this.aniplayData.anilist.length, "개 프레임");
      return true;
    } catch (error) {
      console.error("애니메이션 데이터 준비 중 오류:", error);
      return false;
    }
  },

  // 애니메이션 재생
  playAnimation() {
    //console.log("애니메이션 재생 시작");
    
    // 애니메이션 데이터 확인
    if (!this.aniplayData) {
      if (!this.prepareAnimation()) {
        console.error("애니메이션 데이터를 준비할 수 없습니다");
        return;
      }
    }

    // 이전 타임라인 정리
    this.cleanupTimeline();

    // 애니메이션 상태 설정
    this.isAnimating = true;

    // 좌표 초기화
    let move_posx = Number(this.anielement.model.transx);
    let move_posy = Number(this.anielement.model.transy);
    let move_rotate = Number(this.anielement.model.rotate);
    let move_rotatex = 0;
    let move_rotatey = 0;
    let move_skewx = 0;
    let move_skewy = 0;

    // 새 타임라인 생성 - markRaw로 반응성 제거
    const newTimeline = gsap.timeline({
      onComplete: () => {
        //console.log("애니메이션 완료");
        this.isAnimating = false;
      }
    });

    // 타임라인 할당 - Vue의 반응성을 우회하기 위해 특별한 방법 사용
    this.timeline = markRaw(newTimeline);

    // 초기 위치 설정
    this.timeline.to(this.anielement, { 
      duration: 0, 
      x: move_posx, 
      y: move_posy,
      scaleX: this.anielement.model.scalex, 
      scaleY: this.anielement.model.scaley,
      rotationX: move_rotatex, 
      rotationY: move_rotatey, 
      rotation: move_rotate,
      skewX: move_skewx, 
      skewY: move_skewy,
      alpha: this.anielement.model.alpha 
    });

    // 애니메이션 시퀀스 추가
    this.aniplayData.anilist.forEach((ani, index) => {
      try {
        // 안전하게 숫자 변환
        const getNumber = (value, defaultValue = 0) => {
          const num = Number(value);
          return isNaN(num) ? defaultValue : num;
        };

        // 값 업데이트
        move_posx += getNumber(ani.movex);
        move_posy += getNumber(ani.movey);
        move_rotate += getNumber(ani.rotate);
        move_rotatex += getNumber(ani.rotatex);
        move_rotatey += getNumber(ani.rotatey);
        move_skewx += getNumber(ani.skewx);
        move_skewy += getNumber(ani.skewy);

        // 애니메이션 속성
        const aniprop = { 
          delay: getNumber(ani.delay), 
          duration: getNumber(ani.duration, 1), 
          x: move_posx, 
          y: move_posy,
          scaleX: getNumber(ani.scalex, 1), 
          scaleY: getNumber(ani.scaley, 1),
          rotationX: move_rotatex, 
          rotationY: move_rotatey, 
          rotation: move_rotate,
          skewX: move_skewx, 
          skewY: move_skewy,
          alpha: ani.alpha !== undefined ? getNumber(ani.alpha, 1) : 1
        };

        // ease 속성 설정
        if (ani.ease && ani.easetype) {
          aniprop.ease = `${ani.ease}.${ani.easetype}`;
        }

        // transformOrigin 설정
        if (ani.centerx !== undefined || ani.centery !== undefined) {
          aniprop.transformOrigin = `${getNumber(ani.centerx, 50)}% ${getNumber(ani.centery, 50)}%`;
        }

        // 추가 속성 적용
        if (ani.proplist && Array.isArray(ani.proplist)) {
          ani.proplist.forEach(prop => {
            if (prop && prop.propname) {
              aniprop[prop.propname] = prop.propvalue;
            }
          });
        }

        // 타임라인에 추가
        this.timeline.to(this.anielement, aniprop);
        
      } catch (error) {
        console.error(`프레임 ${index} 처리 중 오류:`, error);
      }
    });

    //console.log(`타임라인 생성 완료 (${this.aniplayData.anilist.length} 프레임)`);
  },

  // 기존 메서드 호환성 유지
  aniplay() {
    this.playAnimation();
  }
}
}
</script>